import { store } from '..';
import { authApi } from './api/auth-api';
import { ServiceResponse } from './service-response';

export class UserService {

  public login = (email, password): Promise<ServiceResponse> => {
    return new Promise(async (resolve) => {
      const result = await store.dispatch(
        authApi.endpoints.login.initiate({ email, password })
      ) as any;

      if (result.error) {
        resolve(ServiceResponse.throwError());
        return;
      }

      resolve(ServiceResponse.success(result.data));
    });
  };

  public requestPasswordReset = (email: string): Promise<ServiceResponse> => {
    return new Promise(async (resolve) => {
      const result = await store.dispatch(
        authApi.endpoints.requestPasswordReset.initiate({ email })
      ) as any;

      if (result.error) {
        resolve(ServiceResponse.throwError());
        return;
      }

      resolve(ServiceResponse.success(result.data));
    });
  };



  public resetPassword = (
    email: string,
    code: string,
    newPassword: string
  ): Promise<ServiceResponse> => {
    return new Promise(async (resolve) => {
      const result = await store.dispatch(
        authApi.endpoints.resetPassword.initiate({ email, code, newPassword })
      ) as any;

      if (result.error) {
        resolve(ServiceResponse.throwError());
        return;
      }

      resolve(ServiceResponse.success(result.data));
    });
  };

  public resetPasswordWithCurrent = (
    email: string,
    currentPassword: string,
    newPassword: string
  ): Promise<ServiceResponse> => {
    return new Promise(async (resolve) => {
      const result = await store.dispatch(
        authApi.endpoints.resetPasswordWithCurrent.initiate({ email, currentPassword, newPassword })
      ) as any;

      if (result.error) {
        resolve(ServiceResponse.throwError());
        return;
      }

      resolve(ServiceResponse.success(result.data));
    });
  };
}